module.exports = __webpack_public_path__ + "static/media/ana-lucena-1.8c3073ee.jpeg";